module.exports = __webpack_public_path__ + "la.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/la.svg
// module id = 654
// module chunks = 0